<template>
  <div>
    <el-card>
      <el-form :model="searchForm" inline label-width="100px" size="small" ref="form">
        <el-form-item label="试卷标题" prop="title">
          <el-input v-model="searchForm.title" placeholder="请输入关键字" />
        </el-form-item>
        <el-form-item label="所属分类" prop="classificationId">
          <el-select v-model="searchForm.classificationId" placeholder="请选择">
            <el-option :label="item.name" :value="item.id" v-for="(item,index) in typeData" :key="index" />
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间" prop="date1">
          <my-datePicker :scopeDate="searchForm.date1" @receiveMyDate="receiveMyDate" />
        </el-form-item>
        <el-form-item label="发布状态" prop="publishStatus">
          <el-select v-model="searchForm.publishStatus" style="width:100%" placeholder="请选择">
            <el-option :label="item.name" :value="item.id" v-for="(item,index) in publishStatus" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="margin-left: 50px">
          <el-button type="primary" @click="search">搜索</el-button>
          <el-button @click="reset('form')" style="margin-left: 8px">重置</el-button>
        </el-form-item>
      </el-form>
      <el-row>
        <el-col>
          <el-button type="primary" @click="action('add')">添加试卷</el-button>
        </el-col>
      </el-row>
    </el-card>
    <br />
    <el-table border v-loading="loading" :data="tableData" style="width: 100%">
      <el-table-column label="试卷标题" prop="title" width="250" align="center" />
      <el-table-column label="发布状态" prop="publishStatus" minWidth="100" align="center">
        <template slot-scope="{row}">
          {{row.publishStatus | publishStatusFilter}}
        </template>
      </el-table-column>
      <el-table-column label="所属分类" prop="title" minWidth="200" align="center">
        <template slot-scope="{row}">
          <!-- {{row.classificationId ? typeData.find(item=>item.id == row.classificationId).name : '--'}} -->
          {{row.examClassification ? row.examClassification.name : '--'}}
        </template>
      </el-table-column>
      <el-table-column label="试卷总分" prop="totalScore" minWidth="200" align="center" />
      <el-table-column label="答卷总次数" prop="answerNum" minWidth="200" align="center" />
      <el-table-column label="全站平均正确率" prop="averageAccuracy" minWidth="200" align="center">
        <template v-slot="{ row }">
          {{ `${row.averageAccuracy}%` }}
        </template>
      </el-table-column>
      <el-table-column label="创建时间" prop="insertDate" minWidth="200" align="center" />
      <el-table-column label="备注" prop="remarks" minWidth="280" align="center" />
      <el-table-column label="操作" minWidth="160" align="center" fixed="right">
        <template slot-scope="{row}">
          <el-button type="text" @click="action('edite',row)">编辑</el-button>
          <el-button type="text" @click="action('del',row)">删除</el-button>
          <el-button type="text" @click="action('detail',row)">试卷详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <br />
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageInfo.page" :page-sizes="pageSizes" layout="total, sizes, prev, pager, next" :total="total" />
    <!-- 添加编辑试卷 -->
    <testPaperAdd ref="testPaperAdd" @update="update"/>
    <!-- 试卷详情 -->
    <!-- <testPaperDetail ref="testPaperDetail" /> -->
  </div>
</template>

<script>
import myDatePicker from "@/components/myDatePicker.vue";
import { publishStatus } from "../dict"
import tableMoudel from "@/libs/mixins/table"
import { examPaperPage, examPaperDel } from "../api"


import testPaperAdd from "./com/add.vue"
// import testPaperDetail from "./com/detail.vue"

import { typeMoudel } from "../mixins"

export default {
  mixins: [tableMoudel, typeMoudel],
  components: { myDatePicker, testPaperAdd },
  data () {
    return {
      publishStatus,
      searchForm: {
        title: null,
        classificationId: null,
        date1: null
      }
    }
  },
  filters: {
    publishStatusFilter (value) {
      return value ? publishStatus.find(item => item.id == value).name : '--'
    },
  },
  created () {
    this.getData()
  },
  methods: {
    async getData (type) {
      if (type == 'init') {
        this.searchForm.date1 = null
        this.searchForm.date2 = null
      }
      const params = { ...this.pageInfo, ...this.searchForm }
       const payload = params.date1
      if (payload && payload.length > 0) {
        params.date1 = payload[0] + " 00:00:00";
        params.date2 = payload[1] + " 23:59:59";
      }
      const res = await examPaperPage(params)
      const { records, total } = res.data
      this.total = Number(total)
      this.tableData = records
    },
    update(){
      this.getData('init')
    },
    action (key, item) {
      switch (key) {
        case 'add':
          this.$refs.testPaperAdd.init()
          break;
        case 'edite':
          this.$refs.testPaperAdd.init(item.id)
          break;
        case 'del':
          this.$confirm('是否确定删除当前试卷?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(async () => {
            const res = await examPaperDel({ id: item.id })
            if (res.code !== 0) return this.$message.warning(res.message)
            this.$message.success('删除成功!')
            this.update()
          })
          break;
        case 'detail':
          const projectId  = item.examClassification ? item.examClassification.projectId : undefined
          // this.$refs.testPaperDetail.init(item.id,item.title ,totalScore,projectId)
          this.$router.push({
            path:"/exercisesAdmin/testPaper/detail",
            query:{
              id:item.id,
              // title:item.title,
              // totalScore,
              projectId
            }
          })
          break;
      }
    },
    receiveMyDate (payload) {
       this.searchForm.date1 = payload
      // this.searchForm.date1 = payload[0] + " 00:00:00";
      // this.searchForm.date2 = payload[1] + " 23:59:59";
    },
  }
}
</script>

<style>
</style>
